import { Box, Typography } from '@mui/material';

export function Disclaimer() {
    return (
        <Box display="flex" justifyContent="center">
            <Typography variant="h1">Disclaimer</Typography>
        </Box>
    );
}
